// extracted by mini-css-extract-plugin
export default {"background":"background--NTR8v"};